import { DatePickerProps, RangePickerProps } from 'antd/es/date-picker';
import { FormInstance, FormItemProps } from 'antd/es/form';
import { InputProps } from 'antd/es/input';
import { TextAreaProps } from 'antd/es/input/TextArea';
import { InputNumberProps } from 'antd/es/input-number';
import { RadioProps } from 'antd/es/radio';
import { RadioGroupProps } from 'antd/es/radio/interface';
import { SelectProps } from 'antd/es/select';
import { ReactNode } from 'react';

import { TagSelectProps } from '@/components/TagSelect';

export enum TemplateType {
  Cascader = 'cascader',
  Custom = 'custom',
  DatePicker = 'date_picker',
  DateRange = 'range_date',
  Input = 'input',
  InputPassword = 'inputPassword',
  TextArea = 'textArea',
  InputNumber = 'inputNumber',
  Select = 'select',
  Radio = 'radio',
  RadioButton = 'radioButton',
  TagSelect = 'tagSelect',
}
export enum FormType {
  Form = 'form',
  SearchForm = 'searchForm',
}

export enum TriggerType {
  Immediate = 'immediate',
  Click = 'click',
}

export type OptionInterface = {
  key?: string | number | boolean;
  value: string | number;
  [attr: string]: any;
};

export interface BaseTplType {
  id: string;
  tpl: TemplateType;
  label?: string | ReactNode;
  disabled?: boolean;
  formItemProps?: FormItemProps;
  className?: string;
}

export interface CascaderTplType extends BaseTplType {
  tpl: TemplateType.Cascader;
  options: Array<OptionInterface>;
  valueField?: string;
  labelField?: string;
  disabled?: boolean;
  disabledWhenEmpty?: boolean;
  placeholder?: string | JSX.Element;
  children?: CascaderTplType;
  // eslint-disable-next-line @typescript-eslint/ban-types
  afterChange?: (form: FormInstance) => void;
  componentProps?: SelectProps;
}

export interface DatePickerTplType extends BaseTplType {
  tpl: TemplateType.DatePicker;
  allowClear?: boolean;
  format?: string;
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year';
  placeholder?: string;
  componentProps?: DatePickerProps;
}

export interface InputNumberTplType extends BaseTplType {
  tpl: TemplateType.InputNumber;
  min: number;
  max: number;
  componentProps?: InputNumberProps;
}

export interface InputTplType extends BaseTplType {
  tpl: TemplateType.Input;
  placeholder?: string;
  componentProps?: InputProps;
}

export interface InputPasswordTplType extends BaseTplType {
  tpl: TemplateType.InputPassword;
  placeholder?: string;
  componentProps?: InputProps;
}

export interface TextAreaTplType extends BaseTplType {
  tpl: TemplateType.TextArea;
  placeholder?: string;
  componentProps?: TextAreaProps;
  extra?: ReactNode;
}

export interface RadioButtonTplType extends BaseTplType {
  tpl: TemplateType.RadioButton;
  options: Array<OptionInterface>;
  labelField?: string;
  valueField?: string;
  componentProps?: RadioGroupProps;
}

export interface RadioTplType extends BaseTplType {
  tpl: TemplateType.Radio;
  options: Array<OptionInterface>;
  labelField?: string;
  valueField?: string;
  componentProps?: RadioProps;
}

export interface RangeDateTplType extends BaseTplType {
  tpl: TemplateType.DateRange;
  format?: string;
  placeholder?: [string, string];
  componentProps?: RangePickerProps;
}

export interface SelectTplType extends BaseTplType {
  tpl: TemplateType.Select;
  options: Array<OptionInterface>;
  labelField?: string;
  valueField?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  placeholder?: string | JSX.Element;
  componentProps?: SelectProps;
}

export interface SelectTplType extends BaseTplType {
  tpl: TemplateType.Select;
  options: Array<OptionInterface>;
  labelField?: string;
  valueField?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  placeholder?: string | JSX.Element;
  componentProps?: SelectProps;
}

export interface TagSelectTplType extends BaseTplType {
  tpl: TemplateType.TagSelect;
  options: Array<OptionInterface>;
  labelField?: string;
  valueField?: string;
  componentProps?: TagSelectProps;
}

export interface CustomTplType extends BaseTplType {
  tpl: TemplateType.Custom;
  render: (val?: CustomTplType) => JSX.Element;
  [key: string]: any;
}
